import { NotificationState } from '@mews-commander/legacy-data-structures';

export function isSeen(notification: $TSFixMe) {
    return NotificationState.getByValue(notification.state) === NotificationState.Seen;
}
